import { ImgUpload } from './ImgUpload';

export default ImgUpload;
